"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
const user_quiz_service_consts_1 = require("@seneca/user-quiz-service-consts");
const errors_1 = require("./errors");
class UserQuizServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
    }
    async fetchTeacherQuiz(quizId) {
        const url = `${this.url}/api/quizzes/me/${quizId}`;
        const expectedResponses = [200, 400, 403, 404];
        const response = await this.requestMaker.makeRequest(url, {
            method: 'GET'
        }, expectedResponses);
        if (response.status === 404) {
            throw new errors_1.QuizDoesNotExistError(quizId);
        }
        if (response.status === 400) {
            const body = response.json;
            throw new errors_1.QuizBadRequestError(body.reason);
        }
        if (response.status === 403) {
            throw new errors_1.UserNotPermittedError();
        }
        return response.json;
    }
    async fetchStudyQuiz(quizId) {
        const url = `${this.url}/api/study/quizzes/me/${quizId}`;
        const expectedResponses = [200, 400, 403, 404];
        const response = await this.requestMaker.makeRequest(url, {
            method: 'GET'
        }, expectedResponses);
        if (response.status === 404) {
            throw new errors_1.QuizDoesNotExistError(quizId);
        }
        if (response.status === 400) {
            const body = response.json;
            throw new errors_1.QuizBadRequestError(body.reason);
        }
        if (response.status === 403) {
            throw new errors_1.UserNotPermittedError();
        }
        return response.json;
    }
    async requestGenerateQuiz(body) {
        const url = `${this.url}/api/quizzes/generate`;
        const expectedResponses = [201, 400, 403];
        const response = await this.requestMaker.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(body)
        }, expectedResponses);
        if (response.status === 400) {
            const body = response.json;
            throw new errors_1.QuizBadRequestError(body.reason);
        }
        if (response.status === 403) {
            throw new errors_1.UserNotPermittedError();
        }
        return response.json;
    }
    async updateTeacherQuiz(_a) {
        var { quizId } = _a, body = __rest(_a, ["quizId"]);
        const url = `${this.url}/api/quizzes/me/${quizId}/update`;
        const expectedResponses = [201, 400, 403, 404];
        const response = await this.requestMaker.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(body)
        }, expectedResponses);
        if (response.status === 400) {
            const body = response.json;
            throw new errors_1.QuizBadRequestError(body.reason);
        }
        if (response.status === 403) {
            throw new errors_1.UserNotPermittedError();
        }
        if (response.status === 404) {
            throw new errors_1.QuizDoesNotExistError(quizId);
        }
        return response.json;
    }
    async fetchAllTeacherQuizOverviews({ status, published, tags, archived, schoolId, pageLimit = user_quiz_service_consts_1.DEFAULT_QUERY_QUIZ_OVERVIEW_LIMIT }) {
        let lastKey;
        let quizOverviews = [];
        do {
            const response = await this.queryTeacherQuizOverviews({
                lastKey,
                status,
                published,
                limit: pageLimit,
                tags,
                archived,
                schoolId
            });
            lastKey = response.lastKey;
            quizOverviews = quizOverviews.concat(response.quizOverviews);
        } while (lastKey);
        return quizOverviews;
    }
    async queryTeacherQuizOverviews({ lastKey, limit = user_quiz_service_consts_1.DEFAULT_QUERY_QUIZ_OVERVIEW_LIMIT, status, published, tags, archived, schoolId }) {
        const url = `${this.url}/api/quizzes/me/query`;
        const expectedResponses = [200, 400];
        const response = await this.requestMaker.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify({
                lastKey,
                limit,
                status,
                published,
                tags,
                archived,
                schoolId
            })
        }, expectedResponses);
        if (response.status === 400) {
            const body = response.json;
            throw new errors_1.QuizBadRequestError(body.reason);
        }
        return response.json;
    }
    async fetchAllSchoolQuizOverviews({ schoolId, status, published, tags, archived, pageLimit = user_quiz_service_consts_1.DEFAULT_QUERY_QUIZ_OVERVIEW_LIMIT }) {
        let lastKey;
        let quizOverviews = [];
        do {
            const response = await this.querySchoolQuizOverviews({
                schoolId,
                lastKey,
                status,
                published,
                limit: pageLimit,
                tags,
                archived
            });
            lastKey = response.lastKey;
            quizOverviews = quizOverviews.concat(response.quizOverviews);
        } while (lastKey);
        return quizOverviews;
    }
    async querySchoolQuizOverviews({ schoolId, lastKey, limit = user_quiz_service_consts_1.DEFAULT_QUERY_QUIZ_OVERVIEW_LIMIT, status, published, tags, archived }) {
        const url = `${this.url}/api/quizzes/schools/${schoolId}/query`;
        const expectedResponses = [200, 400, 403];
        const response = await this.requestMaker.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify({
                lastKey,
                limit,
                status,
                published,
                tags,
                archived
            })
        }, expectedResponses);
        if (response.status === 400) {
            const body = response.json;
            throw new errors_1.QuizBadRequestError(body.reason);
        }
        if (response.status === 403) {
            throw new errors_1.UserNotPermittedError();
        }
        return response.json;
    }
    async createUploadUrl(fileName, contentType) {
        const url = `${this.url}/api/files/upload-url`;
        const expectedResponses = [201, 400, 403, 422];
        const response = await this.requestMaker.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify({ fileName, contentType })
        }, expectedResponses);
        if (response.status === 400) {
            const body = response.json;
            throw new errors_1.QuizBadRequestError(body.reason);
        }
        if (response.status === 403) {
            const body = response.json;
            throw new errors_1.UserNotPermittedError();
        }
        if (response.status === 422) {
            const body = response.json;
            throw new errors_1.FileUploadUnprocessableEntityError(body.reason);
        }
        return response.json;
    }
    async saveTeacherFeedback(requestData) {
        const { quizId } = requestData, body = __rest(requestData, ["quizId"]);
        const url = `${this.url}/api/quizzes/me/${quizId}/feedback`;
        const expectedResponses = [200, 400, 404];
        const response = await this.requestMaker.makeRequest(url, { method: 'POST', body: JSON.stringify(body) }, expectedResponses);
        if (response.status === 404) {
            throw new errors_1.QuizDoesNotExistError(quizId);
        }
        if (response.status === 400) {
            const body = response.json;
            throw new errors_1.QuizBadRequestError(body.reason);
        }
        return response.json;
    }
    async copyQuiz(quizId) {
        const url = `${this.url}/api/quizzes/${quizId}/copy`;
        const expectedResponses = [201, 404, 403, 422];
        const response = await this.requestMaker.makeRequest(url, { method: 'POST' }, expectedResponses);
        switch (response.status) {
            case 500:
                throw new errors_1.InternalServerError(response.json.reason);
            case 404:
                throw new errors_1.QuizDoesNotExistError(quizId);
            case 403:
                throw new errors_1.UserNotPermittedError();
            case 422:
                throw new errors_1.QuizUnprocessableEntityError(quizId);
            case 201:
            case 200:
            default:
                return response.json;
        }
    }
    async saveQuiz(quizId) {
        const url = `${this.url}/api/quizzes/${quizId}/save`;
        const expectedResponses = [200, 201, 404, 403, 422];
        const response = await this.requestMaker.makeRequest(url, { method: 'POST' }, expectedResponses);
        switch (response.status) {
            case 500:
                throw new errors_1.InternalServerError(response.json.reason);
            case 404:
                throw new errors_1.QuizDoesNotExistError(quizId);
            case 403:
                throw new errors_1.UserNotPermittedError();
            case 422:
                throw new errors_1.QuizUnprocessableEntityError(quizId);
            case 201:
            default:
                return response.json;
        }
    }
}
exports.default = UserQuizServiceClient;
//# sourceMappingURL=UserQuizServiceClient.js.map